import {ObjectId} from 'bson';
import { Item, Section, Page, Tag, Focus, Alert, Schedule } from 'schema';
import { itemContext } from 'context';

const getTemplate = props => {
    const {
        userID,
        page
    } = props;
    const pageID = new ObjectId().toString()
    let ids = {
        sections: Array.from({ length: 3 }).map(() => new ObjectId().toString()),
        items: Array.from({ length: 10 }).map(() => new ObjectId().toString())
    }
    
    const items = [
        // Section 1
        new Item({
            _id: ids['items'][0],
            itemID: ids['items'][0],
            content: "{\"blocks\":[{\"key\":\"b71u9\",\"text\":\"Click on a task to edit it ✏️\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
            pageID: pageID,
            sectionID: ids['sections'][1],
            children: {
                INCOMPLETE: [ids['items'][1], ids['items'][2]],
                COMPLETED: []
            },
            createdBy: userID
        }),
        new Item({
            _id: ids['items'][1],
            itemID: ids['items'][1],
            content: "{\"blocks\":[{\"key\":\"7261e\",\"text\":\"Press Tab / Shift + Tab when adding a task to control its hierarchy\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":6,\"length\":3,\"style\":\"CODE\"},{\"offset\":12,\"length\":11,\"style\":\"CODE\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
            pageID: pageID,
            sectionID: ids['sections'][1],
            parents: [ids['items'][0]],
            createdBy: userID
        }),
        new Item({
            _id: ids['items'][2],
            itemID: ids['items'][2],
            content: "{\"blocks\":[{\"key\":\"c9t4p\",\"text\":\"Press Ctrl+E on a text to change it into an inline code\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":6,\"length\":6,\"style\":\"CODE\"}],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
            pageID: pageID,
            sectionID: ids['sections'][1],
            parents: [ids['items'][0]],
            createdBy: userID
        }),

        // Section 2
        new Item({
            _id: ids['items'][3],
            itemID: ids['items'][3],
            content: '{"blocks":[{"key":"b71u9","text":"Press Ctrl+P to open the command bar","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":6,"length":6,"style":"CODE"}],"entityRanges":[],"data":{}}],"entityMap":{}}',
            pageID: pageID,
            sectionID: ids['sections'][2],
            createdBy: userID
        }),
        new Item({
            _id: ids['items'][4],
            itemID: ids['items'][4],
            content: '{"blocks":[{"key":"b71u9","text":"Press Ctrl+B to access the modules","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":6,"length":6,"style":"CODE"}],"entityRanges":[],"data":{}}],"entityMap":{}}',
            pageID: pageID,
            sectionID: ids['sections'][2],
            children: {
                INCOMPLETE: [ids['items'][5], ids['items'][6]],
                COMPLETED: []
            },
            createdBy: userID
        }),
        new Item({
            _id: ids['items'][5],
            itemID: ids['items'][5],
            content: "{\"blocks\":[{\"key\":\"b71u9\",\"text\":\"Drop items into the Calendar module to block out your time\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
            pageID: pageID,
            sectionID: ids['sections'][2],
            parents: [ids['items'][4]],
            createdBy: userID
        }),
        new Item({
            _id: ids['items'][6],
            itemID: ids['items'][6],
            content: "{\"blocks\":[{\"key\":\"b71u9\",\"text\":\"Use the History module to see how well you've done for the past few days\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
            pageID: pageID,
            sectionID: ids['sections'][2],
            parents: [ids['items'][4]],
            createdBy: userID
        }),
    ]

    const sections = [
        new Section({
            _id: ids['sections'][0],
            sectionID: ids['sections'][0],
            section_name: 'Unassigned items',
            pageID: pageID,
        }),
        new Section({
            _id: ids['sections'][1],
            sectionID: ids['sections'][1],
            section_name: 'Here are some basic tricks ✌️',
            pageID: pageID,
            items: {
                INCOMPLETE: [items[0]['itemID']],
                COMPLETED: []
            }
        }),
        new Section({
            _id: ids['sections'][2],
            sectionID: ids['sections'][2],
            section_name: 'Some additional tips for you 😊',
            pageID: pageID,
            items: {
                INCOMPLETE: [items[3]['itemID'], items[4]['itemID']],
                COMPLETED: []
            }
        })
    ]

    const updatedPage = new Page({
        ...page,
        _id: pageID,
        pageID: pageID,
        sections: ids['sections'],
        createdBy: userID,
        page_name: 'Getting started',
        icon: {value: {id: 'rocket'}, type: 'emoji'}
    })

    // console.log({items: items, sections: sections}, props)
    return {items: items, sections: sections, page: updatedPage}
}

export default getTemplate;